export default function countrySwitcher () {
    $ = jQuery;

    $('[data-country-switch]').on('click', function(event) {
        event.preventDefault();

        const el = $(this);
        const code = el.attr('data-country-switch-code');
        const href = el.attr('href');

        let date = new Date();
        date.setTime(date.getTime() + (365*24*60*60*1000));
        const expires = "expires="+date.toUTCString();


        if (code && code !== '') {
            document.cookie = `STYXKEY_country_code=${code};${expires};path=/`;
        }
        if (href && href !== '') window.location.href = href;
    });
}